import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useEffect } from "react";

export const ProtectedRoutes: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, hasCredentials } = useAuth();
  const navigate = useNavigate();
  // https://www.youtube.com/watch?v=W4hBA2gACik
  useEffect(() => {
    if (!isAuthenticated || !hasCredentials) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

    if (!isAuthenticated || !hasCredentials) {
      return <Navigate to="/login" replace />
    }

  if (!isAuthenticated) {
    return null;
  }
  return <>{children}</>;
};
